import { render, staticRenderFns } from "./ForgetPasswordModalComponent.vue?vue&type=template&id=0de83fea"
import script from "./ForgetPasswordModalComponent.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordModalComponent.vue?vue&type=style&index=0&id=0de83fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports